import { Controller } from "react-hook-form";
import {
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const CustomFieldRenderer = ({ field, control, errors, disabled }) => {
  const {
    field_key,
    field_label,
    field_type,
    placeholder,
    is_required,
    options: rawOptions,
  } = field;

  const label = `${field_label}${is_required ? "*" : ""}`;

  const parsedOptions = (() => {
    try {
      return rawOptions ? JSON.parse(rawOptions) : [];
    } catch {
      return [];
    }
  })();

  const rules = is_required
    ? { required: `${field_label} is required` }
    : {};
  
  const errorMsg = errors?.custom_fields?.[field_key]?.message;
  console.log(errors, "errorMsg");

  // Resolve correct empty default per type
  const getDefaultValue = () => {
    switch (field_type) {
      case "checkbox": return false;
      case "date":
      case "dropdown": return null;
      default: return ""; // text, textarea, number
    }
  };

  switch (field_type) {
    case "text":
    case "number":
    case "textarea":
      return (
        <Controller
          name={`custom_fields.${field_key}`}
          control={control}
          rules={rules}
          defaultValue={getDefaultValue()}
          render={({ field: f }) => (
            <TextField
              {...f}
              label={label}
              placeholder={placeholder || ""}
              variant="standard"
              fullWidth
              disabled={disabled}
              type={field_type === "number" ? "number" : "text"}
              multiline={field_type === "textarea"}
              rows={field_type === "textarea" ? 3 : undefined}
              error={!!errorMsg}
              helperText={errorMsg}
            />
          )}
        />
      );

    case "dropdown":
      return (
        <Controller
          name={`custom_fields.${field_key}`}
          control={control}
          rules={rules}
          defaultValue={getDefaultValue()}
          render={({ field: f }) => (
            <Autocomplete
              options={parsedOptions}
              getOptionLabel={(o) => o.label || ""}
              value={parsedOptions.find((o) => o.value === f.value) || null}
              onChange={(_, val) => f.onChange(val?.value ?? null)}
              disabled={disabled}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  placeholder={placeholder || ""}
                  variant="standard"
                  error={!!errorMsg}
                  helperText={errorMsg}
                />
              )}
            />
          )}
        />
      );

    case "date":
      return (
        <Controller
          name={`custom_fields.${field_key}`}
          control={control}
          rules={rules}
          defaultValue={getDefaultValue()}
          render={({ field: f }) => (
            <DatePicker
              {...f}
              label={label}
              format="dd MMM yyyy"
              disabled={disabled}
              slotProps={{
                textField: {
                  variant: "standard",
                  fullWidth: true,
                  placeholder: placeholder || "",
                  error: !!errorMsg,
                  helperText: errorMsg,
                },
              }}
            />
          )}
        />
      );

    case "checkbox":
      return (
        <Controller
          name={`custom_fields.${field_key}`}
          control={control}
          rules={rules}
          defaultValue={getDefaultValue()}
          render={({ field: f }) => (
            <FormGroup sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    {...f}
                    checked={!!f.value}
                    disabled={disabled}
                    color="primary"
                  />
                }
                label={label}
              />
              {errorMsg && (
                <p className="text-danger" style={{ fontSize: "0.75rem" }}>
                  {errorMsg}
                </p>
              )}
            </FormGroup>
          )}
        />
      );

    default:
      return null;
  }
};

export default CustomFieldRenderer;